import src from "IMAGE";
export default { src, width: 560, height: 560, blurWidth: 0, blurHeight: 0};
